// extracted by mini-css-extract-plugin
export default {"button":"cart-button_button__95t++","count":"cart-button_count__dL9+g","content":"cart-button_content__xoacJ","icon":"cart-button_icon__1q2OI","large":"cart-button_large__bdTzz"};